import {
    getZoomLevelFromDistance,
    unixStringToHumanReadable,
} from '../../../common/utils';
import Map from '../../../map/Map';
import ResearchersCard from '../ResearchersCard';

export const transformPlaces = (places) => {
    if (places && places.length) {
        return places.map((place) => {
            return {
                id: place.id,
                updatedBy: place.updatedBy,
                name: place.name,
                mapContent: {
                    MapComponent: Map,
                    center: getMapZoomCenter(
                        place.location ? [place.location] : [],
                    ),
                    dataPoints: transformPlacesPolylineData(
                        place.location ? [place.location] : [],
                    ),
                    zoom: getZoomLevelFromDistance(place.location),
                },
                researchCard: ResearchersCard,
                zoomLevel: 13.0,
                title: place.name,
                userId: place.userId,
                status: place.status,
                address: place.address,
                researchProjectName: place.researchProjectName,
                researchProjectId: place.researchProjectId,
                createdAt: unixStringToHumanReadable(place.createdAt),
                isAssigned: place.isAssigned,
                city: place.city,
                state: place.state,
                postalCode: place.postalCode,
                country: place.country,
                countryCode: place.countryCode,
                location: place.location,
                locationUrl: place.locationUrl,
                locationId: place.locationId,
            };
        });
    } else {
        return [];
    }
};

function getMapZoomCenter(location) {
    return location && location.length
        ? {
              lat: parseFloat(location[0].lat),
              lng: parseFloat(location[0].long),
          }
        : { lat: 0, lng: 0 };
}

function transformPlacesPolylineData(location) {
    return location && location.length
        ? location.map(({ lat, long }) => {
              return {
                  lat: parseFloat(lat),
                  lng: parseFloat(long),
              };
          })
        : [];
}
